import { render, staticRenderFns } from "./CatalogsList.vue?vue&type=template&id=70469d40&"
import script from "./CatalogsList.vue?vue&type=script&lang=js&"
export * from "./CatalogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports